import type { QueryClient } from "@tanstack/react-query";
import { PrivatesAppointmentsApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

export async function prefetchAppointmentScheduleGet(
  appointmentId: number,
  queryClient: QueryClient,
  accessToken?: string,
) {
  if (!accessToken) {
    throw new Error("Access token is required for prefetching appointment schedule");
  }

  const service = createAuthenticatedApi(PrivatesAppointmentsApi, accessToken);

  await queryClient.prefetchQuery({
    queryKey: [QueryKeys.AppointmentSchedule, appointmentId],
    queryFn: () =>
      service.apiAppointmentsIdScheduleGet({
        id: appointmentId,
      }),
    staleTime: 2 * 60 * 1000,
  });

  return queryClient;
}

